document.addEventListener('alpine:init', () => {
	/**
	 * The `cardShare` store used to live here.
	 *
	 * It held the URL and the copied flag for a single shared popup in the footer.
	 * Now that each card renders its own popup inside its own `cardShareButton`
	 * component, both pieces of state belong to that component — which is what fixes
	 * the copy button handing out the first-clicked card's URL for the rest of the
	 * session. See docs/media-flow-review.md S2.
	 */

	Alpine.store('hamburger', {
		open: false,
	});

	Alpine.store('misc', {
		/**
		 * Every live player, so that starting one pauses the rest.
		 *
		 * A plain array that was only ever pushed to: infinite scroll and Swiper's
		 * `loop: true` slide clones kept adding entries, nothing ever removed one, and
		 * each `playing` event then iterated the whole list — including instances whose
		 * DOM had been gone for several pages — calling `.pause()` on each. A Set with
		 * a matching `delete()` in each component's `destroy()` keeps it to what is
		 * actually on the page. See docs/media-flow-review.md P8.
		 */
		players: new Set(),
		locale: '',
		watchLocale: function () {
			this.locale = document.documentElement.lang ?? 'zh-TW';
			const observer = new MutationObserver(() => {
				this.locale = document.documentElement.lang;
			});

			observer.observe(document.documentElement, {
				attributes: true,
				attributeFilter: ['lang'],
			});
		},
		updateScrollbarWidth: function () {
			const scrollbarWidth =
				window.innerWidth - document.documentElement.clientWidth + 1;
			document.documentElement.style.setProperty(
				'--scrollbar-width',
				`${scrollbarWidth}px`
			);
		},
		watchScrollbarWidth: function () {
			this.updateScrollbarWidth();
			window.addEventListener('resize', this.updateScrollbarWidth);
		},
		init: function () {
			this.watchLocale();
			this.watchScrollbarWidth();
		},
	});

	Alpine.store('menu', {
		activeMenuItemId: undefined,
		activeSubMenuItemId: undefined,
		sticky: false,
		init: function () {
			// The `const menuEl = document.querySelector('header')` that stood here fed
			// nothing but the commented-out sticky-header block below — it was read
			// zero times in live code. The block keeps its own reference, so restoring
			// it means un-commenting it wholesale rather than relying on this line.
			/*
        window.addEventListener('scroll', (event) => {
            if (menuEl) {
                const offsetTop = menuEl.offsetTop;
                const shouldBeSticky = window.scrollY >= offsetTop;
                const containSticky = menuEl.classList.contains('sticky');

                if (shouldBeSticky && !containSticky) {
                    menuEl.classList.add(
                        'sticky',
                        'bg-[#f8f8f8]',
                        'top-0',
                        'z-50'
                    );
                } else if (!shouldBeSticky && containSticky) {
                    menuEl.classList.remove(
                        'sticky',
                        'bg-[#f8f8f8]',
                        'top-0',
                        'z-50'
                    );
                }
            }
        });
        */
		},
	});

	Alpine.store('miniPlayer', {
		isShown: false,
		type: undefined,
		thumbnail: undefined,
		src: undefined,
		element: undefined,
		html: undefined,
		player: undefined,
		close: function () {
			/**
			 * Closing used to pause but never destroy, so the Vidstack instance, its
			 * listeners and its media element stayed resident behind a hidden wrapper
			 * (P9). Emptying the wrapper is now sufficient teardown: the media element
			 * is a custom element, and removing it from the DOM fires its native
			 * disconnectedCallback. Pausing first stops the audio a frame sooner.
			 */
			const wrapper = document.querySelector('#mini-player-wrapper');

			wrapper?.querySelector('[slot="media"]')?.pause?.();
			wrapper?.replaceChildren();

			this.player = undefined;
			this.isShown = false;
		},
	});
});
